import React, { Component } from 'react';
import { Router, Switch, Route } from 'react-router-dom';

import { Layout } from 'antd';
import { Profile } from './pages/profile/Profile';
import { Projects } from './pages/Projects/Projects';
import { Project } from './pages/Project/Project';

import SelectionContext from 'utils/SelectionContext';
import ModalContext from 'utils/ModalContext';
import ModalProvider from 'utils/ModalProvider';

import { history } from './utils/history';
import Header from './layout/header/Header';

import { PrivateRoute } from 'components/navigation/PrivateRoute';
import { Agreement } from 'pages/Legal/Agreement';
import { ThemeProvider } from './theme';

import 'antd/dist/reset.css';
import './App.sass';

const SelectionConsumer = SelectionContext.Consumer;
const ModalConsumer = ModalContext.Consumer;

interface Props {
	returnTo: string;
}
interface State { }

export default class App extends Component<Props, State> {
	state = {
		selection: null,
	};

	render() {
		return (
			<ThemeProvider>
				<div id="App">
					<Router history={history}>
						<Layout className={'Layout'} style={{ paddingTop: '88px' }}>
							<Header></Header>

							<Layout.Content>
								<ModalProvider>
									<ModalConsumer>
										{(modalProps) => (
											<Switch>
												<Route
													key="agreement"
													path="/agreement"
													exact={
														true
													}
												>
													<Agreement
														auth0Domain={this.props.auth0Domain}
														expanded={
															this
																.state
																.isExpanded
														}
														setExpanded={(
															value
														) => {
															this.setState(
																{
																	isExpanded:
																		value
																}
															);
														}}></Agreement>
												</Route>
												<PrivateRoute key="profile" path="/profile">
													<Profile {...modalProps} returnTo={this.props.returnTo}></Profile>
												</PrivateRoute>
												<PrivateRoute key="project" path="/projects/:id">
													<Project {...modalProps}></Project>
												</PrivateRoute>
												<PrivateRoute key="projects" path="/projects">
													<Projects {...modalProps}></Projects>
												</PrivateRoute>
												<PrivateRoute key="projectsRoot" exact={true} path="">
													<Projects {...modalProps}></Projects>
												</PrivateRoute>
											</Switch>
										)}
									</ModalConsumer>
									<ModalConsumer>
										{({ modals, popModal }) => {
											return modals.map((m: any, index) => {
												return React.cloneElement(m, {
													key: m.key || index,
													show: true,
													visible: true,
													onHide: popModal,
												});
											});
										}}
									</ModalConsumer>
								</ModalProvider>
								<Layout.Footer>

									<div id="copyright" className="noselection">

										© {new Date().getFullYear()} Gerositus Sàrl - All rights reserved

									</div>
								</Layout.Footer>

							</Layout.Content>
						</Layout>
					</Router>

				</div>
			</ThemeProvider>
		);
	}
}
